import React from 'react';

const ForwardIcon = (props) => (
  <svg width={1920} height={1920} viewBox="0 0 1920 1920" {...props}>
    <path
      d="M1691.101 1035.722L1155.825 1571c-37.49 37.49-98.277 37.488-135.765 0-37.49-37.49-37.493-98.271 0-135.765l379.176-379.175H287.993c-53.016 0-95.993-42.984-95.993-96 0-53.02 42.988-96 95.993-96h1112.243L1021.06 484.884c-37.49-37.491-37.488-98.277 0-135.765 37.49-37.49 98.271-37.493 135.765 0l542.815 542.815a96.61 96.61 0 0 1 2.222 2.28 95.61 95.61 0 0 1 18.6 28.491c4.854 11.482 7.538 24.105 7.538 37.354 0 12.921-2.553 25.246-7.182 36.498-4.686 11.417-11.665 22.113-20.936 31.384a96.975 96.975 0 0 1-8.78 7.781z"
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
    />
  </svg>
);

export default ForwardIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/ForwardIcon.js